/**
 * Functions and vars shared between axes-prerender and axes-postrender.
 */
export const YEAR_MILLISECONDS = 1000 * 60 * 60 * 24 * 365;



// WEBPACK FOOTER //
// ./src/chart/inner/axes-common.js